/* eslint-disable */

import { getFlagValue, setFlagValue } from '../api';
import { parse } from 'iso8601-duration';

API.LMSFinish = function(input) {
  console.log('LMSTerminate::', input);
  if (!getFlagValue('flagInitialized') || getFlagValue('flagFinished')) {
    return false;
  }
  var lessonstatus = API.LMSGetValue('cmi.core.lesson_status');
  var mastery_score = parseInt(API.LMSGetValue_F('adlcp:masteryscore'));
  var score_raw = parseInt(API.LMSGetValue_F('adlcp:masteryscore'));

  if (lessonstatus === 'not attempted') {
    // API.LMSSetValue_F('cmi.core.lesson_status', 'browsed'); or //incomplete
    // debugger;
    if (
      API.LMSGetValue_F('adlcp:masteryscore') === '' ||
      !API.LMSGetValue_F('adlcp:masteryscore')
    ) {
      // API.LMSSetValue_F('cmi.core.lesson_status', 'completed');
    } else {
      if (score_raw >= mastery_score) {
        API.LMSSetValue_F('cmi.core.lesson_status', 'passed');
      } else {
        API.LMSSetValue_F('cmi.core.lesson_status', 'failed');
      }
    }
  }
  // else {
  //   API.LMSSetValue_F('cmi.core.lesson_status', 'not attempted');
  // }

  var exit = API.LMSGetValue_F('cmi.core.exit');
  if (exit == 'suspend') {
    API.LMSSetValue_F('cmi.core.entry', 'resume');
  } else {
    API.LMSSetValue_F('cmi.core.entry', '');
  }

  // read cmi.core.total_time from the 'scormvars' table
  var totalTime = API.LMSGetValue_F('cmi.core.total_time');
  if (typeof totalTime === 'undefined') {
    API.LMSSetValue_F('cmi.core.total_time', '0000:00:00.00');
    API.LMSSetValue_F('cmi.core.session_time', '0000:00:00.00');
    API.LMSCommit('', true);

    setFlagValue('flagFinished', true);
    data = {};
    return true;
  }
  // convert total time to seconds
  var time = totalTime.split(':');
  var totalSeconds = parseInt(time[0] * 60 * 60) + parseInt(time[1] * 60) + parseInt(time[2]);

  // read the last-set cmi.core.session_time from the 'scormvars' table
  var sessionTime = API.LMSGetValue_F('cmi.core.session_time');
  // no session time set by SCO - set to zero
  if (!sessionTime) {
    sessionTime = '0000:00:00';
  }

  // convert session time to seconds
  time = sessionTime.split(':');
  var sessionSeconds = parseInt(time[0] * 60 * 60) + parseInt(time[1] * 60) + parseInt(time[2]);
  // debugger;
  // new total time is ...
  // totalSeconds += sessionSeconds;
  totalSeconds = parseInt(totalSeconds) + parseInt(sessionSeconds);

  // break total time into hours, minutes and seconds
  var totalHours = parseInt(totalSeconds / 3600);
  totalSeconds -= totalHours * 3600;
  var totalMinutes = parseInt(totalSeconds / 60);
  totalSeconds -= totalMinutes * 60;

  // save new total time to the 'scormvars' table
  API.LMSSetValue_F('cmi.core.total_time', totalHours + ':' + totalMinutes + ':' + totalSeconds);

  //delete the last session time
  API.LMSSetValue_F('cmi.core.session_time', '0000:00:00.00');

  API.LMSCommit('', true);
  // flagFinished = true;
  setFlagValue('flagFinished', true);
  data = {};
  return true;
};

API_1484_11.Terminate = function(input) {
  console.log('LMSTerminate::', input);
  if (!getFlagValue('flagInitialized') || getFlagValue('flagFinished')) {
    return false;
  }
  var lessonstatus = API_1484_11.GetValue('cmi.completion_status');

  if (lessonstatus === 'not attempted') {
    API.LMSSetValue_F('cmi.completion_status', 'completed');
  }

  API.LMSSetValue_F('cmi.entry', '');
  var exit = API.LMSGetValue_F('cmi.exit');
  if (exit == 'suspend') {
    API.LMSSetValue_F('cmi.entry', 'resume');
  } else {
    API.LMSSetValue_F('cmi.entry', '');
  }

  // read cmi.core.total_time from the 'scormvars' table
  var totalTime = API.LMSGetValue_F('cmi.total_time');
  // convert total time to seconds
  var time = totalTime.split(':');
  var totalSeconds = parseInt(time[0] * 60 * 60) + parseInt(time[1] * 60) + parseInt(time[2]);

  // read the last-set cmi.core.session_time from the 'scormvars' table
  var sessionTime = API.LMSGetValue_F('cmi.session_time');

  // console.log('before condition session time', sessionTime);
  // no session time set by SCO - set to zero
  if (!sessionTime) {
    sessionTime = '0000:00:00';
  }

  // convert session time to seconds
  time = sessionTime.split(':');
  var sessionSeconds = parseInt(time[0] * 60 * 60) + parseInt(time[1] * 60) + parseInt(time[2]);

  if (sessionTime.indexOf('P') > -1) {
    sessionSeconds = parse(sessionTime).seconds;
  }

  // new total time is ...
  totalSeconds = parseInt(totalSeconds) + parseInt(sessionSeconds);
  // break total time into hours, minutes and seconds
  var totalHours = parseInt(totalSeconds / 3600);
  totalSeconds -= totalHours * 3600;
  var totalMinutes = parseInt(totalSeconds / 60);
  totalSeconds -= totalMinutes * 60;

  // save new total time to the 'scormvars' table
  API.LMSSetValue_F('cmi.total_time', totalHours + ':' + totalMinutes + ':' + totalSeconds);

  //delete the last session time
  API.LMSSetValue_F('cmi.session_time', '0000:00:00.00');

  API_1484_11.Commit('');
  // flagFinished = true;
  setFlagValue('flagFinished', true);
  data = {};
  return true;
};

window.APIBackup = Object.assign({}, window.API);
window.API_1484_11Backup = Object.assign({}, window.API_1484_11);
